// extracted by mini-css-extract-plugin
export var slider = "slider-module--slider--1ww8I";
export var slider__title = "slider-module--slider__title--q+Yzh";
export var slider__container = "slider-module--slider__container--t1L1L";
export var slider__card = "slider-module--slider__card--25nsT";
export var slider__cardHeader = "slider-module--slider__card-header--mXVuY";
export var slider__cardImage = "slider-module--slider__card-image--jKae3";
export var slider__cardName = "slider-module--slider__card-name--Q11-C";
export var slider__cardListItem = "slider-module--slider__card-list-item--onj7k";